import { Component, Input, ViewEncapsulation,  EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'nbx-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  // encapsulation: ViewEncapsulation.ShadowDom
})
export class InputComponent {
  @Input() shape = "semi-round";
  @Input() size = "medium";
  @Input() status = "basic";
  @Input() disabled = "false";
  @Input() type = "text";
  @Input() placeholder = "Input"

  @Output() getinput = new EventEmitter()


  sendInput(event) {
    var inputVal = event.target.value;

    this.getinput.emit(inputVal);
  }
}
